module.exports = __webpack_public_path__ + "img/dc-actions-lv.baf00298.png";